document.addEventListener("DOMContentLoaded", function () {
    const marqueeSwiper = new Swiper(".featuredImages_slider", {
        slidesPerView: "auto",
        spaceBetween: 16,
        loop: true,
        speed: 3000,
        autoplay: {
            delay: 0,
            disableOnInteraction: false
        },
        allowTouchMove: true,
        freeMode: {
            enabled: true,
            momentum: false
        }
    });

    const marqueeContainer = document.querySelector(".featuredImages_slider");
    marqueeContainer.addEventListener("mouseenter", () => marqueeSwiper.autoplay.stop());
    marqueeContainer.addEventListener("mouseleave", () => marqueeSwiper.autoplay.start());

    let popupSwiper;

    function updateSwiperCounter(swiper) {
        const totalSlides = swiper.slides.length / (swiper.loopedSlides ? 3 : 1); // Adjust for duplicate slides
        const currentSlide = swiper.realIndex + 1;
        const paginationEl = swiper.el.closest(".featuredImages_popup").querySelector(".swiper-counter");
    
        if (paginationEl) {
            paginationEl.innerHTML = `<span class="count">${currentSlide.toString().padStart(2, "0")}</span>/<span class="total">${totalSlides.toString().padStart(2, "0")}</span>`;
        }
    }

    function initPopupSwiper(initialIndex = 0) {
        if (popupSwiper) {
            popupSwiper.destroy(true, true);
        }

        popupSwiper = new Swiper(".featuredImages_popup--container", {
            slidesPerView: "auto",
            loop: true,
            centeredSlides: true,
            spaceBetween: 16,
            navigation: {
                nextEl: ".featuredImages_popup .swiper-button-next",
                prevEl: ".featuredImages_popup .swiper-button-prev"
            },
            autoplayDisableOnInteraction: false,
            initialSlide: initialIndex,
            mousewheel: {
                forceToAxis: true,
                releaseOnEdges: true,
            },
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            on: {
                init: function (swiper) {
                    updateSwiperCounter(swiper);
                },
                slideChange: function (swiper) {
                    updateSwiperCounter(swiper);
                }
            }
        });
        
    }

    document.querySelectorAll(".featuredImages_slider--slide").forEach((slide) => {
        slide.addEventListener("click", function () {
            const swiperIndex = parseInt(slide.getAttribute("data-swiper-slide-index"), 10);

            const popupWrapper = document.querySelector(".featuredImages_popup");
            popupWrapper.classList.add("popup_show");

            setTimeout(() => {
                initPopupSwiper(swiperIndex);
            }, 100);


        });
    });

    function closePopup() {
        document.querySelector(".featuredImages_popup").classList.remove("popup_show");

        if (popupSwiper) {
            popupSwiper.destroy(true, true);
            popupSwiper = null;
        }
        marqueeSwiper.autoplay.start();

    }

    document.querySelector(".featuredImages_popup--close").addEventListener("click", closePopup);
    document.querySelector(".featuredImages_popup").addEventListener("click", function (event) {
        if (event.target.classList.contains("featuredImages_popup")) {
            closePopup();
        }
    });
});
